import { render, staticRenderFns } from "./ViewOfficeDataChangeModal.vue?vue&type=template&id=0712530b&"
import script from "./ViewOfficeDataChangeModal.vue?vue&type=script&lang=js&"
export * from "./ViewOfficeDataChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports